import { convertFieldToJqlTerm } from './convert-field-to-jql-term.tsx';

export const getJqlTermForField = (field: string, fieldToJqlTermMap: Map<string, string>) => {
	const convertedField = convertFieldToJqlTerm(field);
	const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
	return jqlTermForField;
};
